import store from "@/store";

export default {
    toPrettyDate(d) {
        let days = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
        var pad = function (num) { return ('00' + num).slice(-2) };
        let date = new Date(d);
        date = days[date.getDay()] + " " + pad(date.getUTCDate()) + '/' +
            pad(date.getUTCMonth() + 1) + '/' +
            date.getUTCFullYear();
        return date;
    },
    displayMenu() {
        if (window.innerWidth >= 1660) {
            store.commit('toggleMenu', true);
        } else {
            store.commit('toggleMenu', false);
        }
    },
    decimalToHour(decimal) {
        return `${String((Math.floor(decimal))).padStart(2, '0')}h${String(Math.floor((decimal - Math.floor(decimal)) * 60)).padStart(2, '0')}`;
    }
}